export const getNestedProperty = (object, path) => {
    return path.split('.').reduce((acc, curr) => {
        return acc[curr];
    }, object)
}